import React from 'react';
import { ShieldCheck, Zap, Clock, ArrowRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function PricingCTA() {
  return <section id="pricing" className="py-14 px-6 relative overflow-hidden bg-[#0a0a0a]" data-id="element-236">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[500px] bg-brand-rose/8 rounded-full blur-[120px] pointer-events-none" data-id="element-237" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-238">
        <FadeIn data-id="element-239">
          <div className="text-center mb-8" data-id="element-240">
            <span className="text-brand-rose font-medium tracking-wider uppercase text-sm mb-3 block" data-id="element-241">
              Oferta Especial
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-3" data-id="element-242">
              Todo esto por menos de lo que <br className="hidden md:block" data-id="element-243" />
              <span className="text-brand-rose italic" data-id="element-244">cuesta un café</span>
            </h2>
            <p className="text-brand-lightGray text-lg max-w-2xl mx-auto" data-id="element-245">
              Mientras sigues dudando qué escribirle, otra mujer ya está usando
              este sistema. La pregunta no es si funciona — es cuánto más vas a
              esperar.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-246">
          {/* Product Image */}
          <FadeIn direction="left" data-id="element-247">
            <div className="relative flex justify-center" data-id="element-248">
              <div className="absolute inset-0 bg-brand-rose/10 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-249" />
              <img src="https://cdn.magicpatterns.com/uploads/7R22mtG57mGYPgAvs9jphH/ChatGPT_Image_29_mar_2026,_07_57_39_p.m..png" alt="Nunca Más Te Dejan en Visto — disponible en todos tus dispositivos" className="relative z-10 w-full max-w-lg rounded-2xl" data-id="element-250" />
            </div>
          </FadeIn>

          {/* Pricing Card */}
          <FadeIn direction="right" data-id="element-251">
            <div className="relative bg-brand-gray/40 border border-white/10 rounded-3xl p-6 md:p-8 overflow-hidden" data-id="element-252">
              {/* Top accent bar */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-rose to-rose-400" data-id="element-253" />

              <p className="text-brand-lightGray text-sm uppercase tracking-wider mb-1" data-id="element-254">
                Acceso completo e inmediato
              </p>
              <h3 className="font-serif text-2xl font-bold text-brand-cream mb-4" data-id="element-255">
                "Nunca Más Te Dejan en Visto"
              </h3>

              {/* Price */}
              <div className="flex items-baseline gap-3 mb-1" data-id="element-256">
                <span className="text-brand-lightGray line-through text-2xl" data-id="element-257">
                  $27
                </span>
                <span className="font-serif text-6xl font-bold text-brand-cream" data-id="element-258">
                  $7
                </span>
                <span className="text-brand-lightGray text-lg" data-id="element-259">USD</span>
              </div>
              <p className="text-brand-rose font-medium text-sm mb-6" data-id="element-260">
                🔥 Precio de lanzamiento — por tiempo limitado
              </p>

              {/* Benefits */}
              <div className="space-y-3 mb-4" data-id="element-261">
                <div className="flex items-center gap-3 text-brand-cream" data-id="element-262">
                  <Zap className="w-5 h-5 text-brand-rose shrink-0" data-id="element-263" />
                  <span className="text-sm" data-id="element-264">
                    Acceso inmediato después de la compra
                  </span>
                </div>
                <div className="flex items-center gap-3 text-brand-cream" data-id="element-265">
                  <ShieldCheck className="w-5 h-5 text-brand-rose shrink-0" data-id="element-266" />
                  <span className="text-sm" data-id="element-267">Guía completa paso a paso</span>
                </div>
                <div className="flex items-center gap-3 text-brand-cream" data-id="element-268">
                  <Clock className="w-5 h-5 text-brand-rose shrink-0" data-id="element-269" />
                  <span className="text-sm" data-id="element-270">Aplícalo desde el primer día</span>
                </div>
              </div>

              {/* Bonus included */}
              <div className="p-4 bg-amber-500/10 border border-amber-500/20 rounded-xl mb-6" data-id="element-271">
                <p className="text-amber-400 font-bold text-sm mb-2" data-id="element-272">
                  🎁 BONUS GRATIS INCLUIDO:
                </p>
                <ul className="space-y-1.5 text-brand-cream text-sm" data-id="element-273">
                  <li className="flex items-center gap-2" data-id="element-274">
                    <span className="text-amber-400" data-id="element-275">✔</span> 50 mensajes
                    listos para copiar y pegar
                  </li>
                  <li className="flex items-center gap-2" data-id="element-276">
                    <span className="text-amber-400" data-id="element-277">✔</span> Respuestas para
                    cuando te deja en "visto"
                  </li>
                  <li className="flex items-center gap-2" data-id="element-278">
                    <span className="text-amber-400" data-id="element-279">✔</span> Frases para
                    reactivar chats muertos
                  </li>
                </ul>
                <p className="text-amber-400/70 text-xs mt-2" data-id="element-280">
                  Valor: <span className="line-through" data-id="element-281">$15</span> → GRATIS con
                  tu compra
                </p>
              </div>

              {/* CTA Button */}
              <motion.a href="https://oliverpublicista-2.myshopify.com/cart/43150580056154:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} className="w-full group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-brand-rose text-white text-lg font-bold rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(225,29,72,0.3)] hover:shadow-[0_0_50px_rgba(225,29,72,0.5)] transition-shadow" data-id="element-282">
                <span className="relative z-10 flex items-center gap-2" data-id="element-283">
                  Quiero Mi Copia Ahora
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-284" />
                </span>
                <div className="absolute inset-0 bg-white/15 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-285" />
              </motion.a>

              <p className="text-center text-brand-lightGray/60 text-xs mt-3" data-id="element-286">
                Pago seguro • Acceso de por vida
              </p>

              {/* Urgency nudge */}
              <div className="mt-4 p-3 bg-brand-dark/60 rounded-xl border border-brand-rose/10 text-center" data-id="element-287">
                <p className="text-sm text-brand-cream italic" data-id="element-288">
                  "Un solo mensaje puede acercarlo… o perderlo para siempre.{' '}
                  <br data-id="element-289" />
                  <span className="text-brand-rose font-semibold not-italic" data-id="element-290">
                    ¿Cuánto vale saber exactamente qué decir?
                  </span>
                  "
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}